import { CustomIdentity } from '../../models/interfaces/custom_identity.interface';
import { AuthActions, LOG_IN, LOG_OUT, SET_IDENTITY } from './auth.actions';

export interface State {
  isLoggedIn: boolean;
  identity: CustomIdentity | null;
}

const initialState: State = {
  isLoggedIn: false,
  identity: null
};

export function authReducer(state = initialState, action: AuthActions) {
  switch (action.type) {
    case LOG_IN:
      return {
        ...state,
        isLoggedIn: true
      };
    case LOG_OUT:
      return {
        ...state,
        isLoggedIn: false
      };
    case SET_IDENTITY:
      return {
        ...state,
        identity: action.payload
      };
    default: {
      return state;
    }
  }
}

export const getIsLoggedIn = (state: State) => state.isLoggedIn;
export const getIdentity = (state: State) => state.identity;
